import { Button, useRedirect } from 'react-admin';
import AddIcon from '@mui/icons-material/Add';

const CustomCreateButton = ({basePath}) => {

  const handleClick = () => {
    const url = `${window.location.origin}/#${basePath}/create`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
  };

  return (
    <Button label="登録" onClick={handleClick}>
      <AddIcon style={{ marginRight: 4 }} />
    </Button>
  );
};

export default CustomCreateButton;